import { call, put, takeLeading, delay } from 'redux-saga/effects';
import settings from '../api/settings';
import { settingsActions } from '../reducers/settings';


function* settingsDataRequest({ payload }: any): any {   
    const res = yield call(settings.fetchSettings, payload);
    if (res.status === 'success') {
        yield put(settingsActions.getSettingsDataResponse(res));
    } else {        
        yield put(settingsActions.getSettingsDataFailed());
    }
}

function* addSettings({ payload }: any): any {
    // yield delay(1000);
    const res = yield call(settings.saveSettings, payload);
    if (res.status === 'success') {             
        yield put(settingsActions.addSettingsResponse(res.code));
    } else {
        yield put(settingsActions.addSettingsFailed(res));
    }
}

function* updateSettings({ payload }: any): any {
    // yield delay(1000);
    const res = yield call(settings.updateSettings, payload);
    if (res.status === 'success') {
        yield put(settingsActions.updateSettingsRequest(res.data));
    } else {
        yield put(settingsActions.updateSettingsFailed(res));
    }
}


function* fetchMenuDataRequest({ payload }: any): any {   
    const res = yield call(settings.fetchMenu, payload);
    if (res.status === 'success') {    
        yield put(settingsActions.getMenuResponse(res.data));
    } else {        
        yield put(settingsActions.getMenuFailed(res));
    }
}



function* settingsSaga() {
    yield takeLeading('settings/getSettingsDataRequest', settingsDataRequest);
    yield takeLeading('settings/addSettingsRequest', addSettings);
    yield takeLeading('settings/updateSettingsRequest', updateSettings);
    yield takeLeading('settings/getMenuRequest', fetchMenuDataRequest);
}

export default settingsSaga;